import script from "./NotificationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationModal.vue?vue&type=script&setup=true&lang=js"

import "./NotificationModal.vue?vue&type=style&index=0&id=c66883ea&lang=less"
import "./NotificationModal.vue?vue&type=style&index=1&id=c66883ea&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/build_logistics-fe-ntp-hz_7239acc82b1549feaf711c841a4f224f/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c66883ea"]])

export default __exports__